'use client';

import React, { useState } from 'react';

interface TravelCircleFormProps {
  placeholder: string;
  buttonText: string;
  buttonStyle?: 'primary' | 'light';
}

export function TravelCircleForm({ placeholder, buttonText, buttonStyle = 'primary' }: TravelCircleFormProps) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Redirect to Stripe payment link
    window.open('https://buy.stripe.com/7sYdR8enNfjEcGe3vkc3m00', '_blank');
  };

  const buttonClasses = buttonStyle === 'primary'
    ? 'bg-primary-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-primary-550 transition-colors whitespace-nowrap text-sm'
    : 'bg-white text-primary-900 px-5 py-2.5 rounded-lg font-semibold hover:bg-neutral-cream transition-colors whitespace-nowrap text-sm';

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2.5 max-w-lg mx-auto">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={placeholder}
        required
        autoComplete="email"
        className="flex-1 px-3.5 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors"
      />
      <button
        type="submit"
        className={buttonClasses}
      >
        {buttonText}
      </button>
    </form>
  );
}
